import {BizTypeList} from "./BizTypeList";
import {BizTypeEdit} from "./BizTypeEdit";
import {BizTypeCreate} from "./BizTypeCreate";

export default {
    list: BizTypeList,
    create: BizTypeCreate,
    edit: BizTypeEdit
};
